import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';
import { UtilsAccentsModule } from '@unico-people/shared/utils/pipes/utils-accents';

import { HeaderComponent } from './header.component';

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  imports: [RouterModule, CommonModule, MatDialogModule, UiCopyButtonModule, UtilsAccentsModule]
})
export class HeaderModule {}
